interface MultiAccountTab {
  id: number;
  label: string;
}

export const multiAccountTabs: MultiAccountTab[] = [
  {
    id: 0,
    label: 'multiAccount.members',
  },
  {
    id: 1,
    label: 'multiAccount.priority',
  },
];
